import { createSlice, current } from "@reduxjs/toolkit";

export const initialState = {
 plans : [],
 loading: false,
 current_plan_details:{},
 billings:[],
 payment_methods:[],
 default_payment_methods:null,
 Add_On_Plan_Details:[],
 plan_features_available:[],
 current_plan_type: null,
};

const planSlice = createSlice({
  name: "Plans",
  initialState,
  reducers: {
    set_Plans(state, action) {
      state.plans = action.payload.plans
      state.loading = false;
    },

    set_current_plan_type(state, action) {
      state.current_plan_type = action.payload
    },

    stop_plan_loading(state){
       state.loading = false
    },
    start_Plan_loading(state, action) {
        state.loading = true;
    },
    set_Plans_Failed(state, action) {
        // state.plans = [];
        state.loading = false;
    },
    set_current_plan_details(state, action) {
      state.loading = false;
      state.current_plan_details = action.payload
    },
    set_billing_details(state,action){
      state.loading = false;
      state.billings =  action.payload
    },
    set_payment_method(state, action){
      state.loading = false;
      state.payment_methods = action.payload
    },
    set_default_payment_method(state, action){
        state.loading = false;
        state.default_payment_methods = action.payload
    },
    set_add_on_plan_details(state, action){
      state.loading = false;
      state.Add_On_Plan_Details=action.payload;
    },
    set_payment_summary_failed(state, action){
      state.current_plan_details = {}
      state.loading = false;
    },
    set_plan_features(state, action){
      state.loading = false;
      state.plan_features_available = action.payload

    }
 
  },
});

export const {
  set_current_plan_type,
  set_Plans,
  start_Plan_loading,
  set_Plans_Failed,
  stop_plan_loading,
  set_current_plan_details,
  set_billing_details,
  set_payment_method,
  set_default_payment_method,
  set_add_on_plan_details,
  set_payment_summary_failed,
  set_plan_features
} = planSlice.actions

export default planSlice.reducer;